import React, {Component} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import OtherTable from '../common/otherTable';
import {ajax, unparam} from '../../../../../utils/common';

class Conclusion extends Component {
  state = {
    options: {
      credits: {
        enabled: false
      },
      chart: {
        backgroundColor: 'transparent',
        height: 224
      },
      title: null,
      colors: this.props.chatColor,
      tooltip: {
        pointFormat: `${this.props.i18n.report.summaryInfo3}: {point.y}<br/>${this.props.i18n.report.summaryInfo4}: {point.strengthDesc}`
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}: {point.percentage:.1f}% {point.strengthDesc}',
            style: {
              color: '#777777',
              fontSize: 12,
              fontWeight: 'normal'
            }
          }
        }
      },
      series: []
    }
  }

  signCharacterReport = (useful) => {
    const queryString = unparam(location.search);
    ajax({
      url: "/account/signCharacterReport",
      method: 'post',
      data: {
        hrInfo: queryString.hrInfo,
        useful
      }
    }).then(res => {
      this.props.updateUserInfo && this.props.updateUserInfo();
    }).catch(err => {
      console.log("result fail: ", err)
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.summary && nextProps.summary.emos && this.state.options.series.length === 0) {
      const emos = nextProps.summary && nextProps.summary.emos || {};
      let arr = [];
      for(let i in emos) {
        if(i !== 'attention') {
          arr.push({
            name: emos[i].emotion,
            y: emos[i].score,
            strengthDesc: emos[i].strengthDesc
          });
        }
      }
      this.setState({
        options: {
          series: [{
            type: 'pie',
            innerSize: '60%',
            data: arr
          }]
        }
      });
    }
  }

  render() {
    const { options } = this.state;
    const { themeColor, i18n, summary, chatColor, useful } = this.props;

    const columns = () => {
      return [{
        title: i18n.report.summaryInfo5,
        dataIndex: 'emotion',
        key: 'emotion',
        align: 'center',
        render: (text, record, index) => <div className="tableTitle">
          <span style={{backgroundColor: chatColor[index++]}} />{text}
        </div>
      },{
        title: i18n.report.summaryInfo3,
        dataIndex: 'score',
        key: 'score',
        align: 'center'
      }, {
        title: i18n.report.summaryInfo4,
        dataIndex: 'strengthDesc',
        key: 'strengthDesc',
        align: 'center',
        render: (text, record) => <React.Fragment>
          {record.strength === 1 ? <strong>{text}</strong> : text}
        </React.Fragment>
      }];
    }

    const dataSource = () => {
      const arr = [];
      const emos = summary && summary.emos || {};
      for(let i in emos) {
        if(i !== 'attention') {
          arr.push({key: i, emotion: i18n.report.emotion[i], ...emos[i]});
        }
      }
      return arr;
    }

    return (
      <div className="conclusion video-mobile-box">
        <div className="conclusionTitleBox">
          <h1 className="conclusionTitle" style={{color: themeColor}}>{i18n.result.summaryTitle}</h1>
          <div className="expressionList">
            <div className="expressionBtn" onClick={() => useful != 1 && this.signCharacterReport(1)}
                 style={useful == 1 ? {color: '#fff', borderColor: themeColor, backgroundColor: themeColor} : {}}><span style={useful == 1 ? {color: '#fff'} : {}} className="iconfont icon-90tubiaoku-230" />{i18n.result.expressText1}</div>
            <div className="expressionBtn" onClick={() => useful != 0 && this.signCharacterReport(0)}
                 style={useful == 0 ? {color: '#fff', borderColor: themeColor, backgroundColor: themeColor} : {}}><span style={useful == 0 ? {color: '#fff'} : {}} className="iconfont icon-90tubiaoku-229" />{i18n.result.expressText2}</div>
          </div>
        </div>
        <div className="conclusionTop">
          <p dangerouslySetInnerHTML={{__html: summary.emos && summary.emos.attention && i18n.report.summaryInfo1.replace('${num}', `<strong> ${summary.emos.attention.score}</strong>`).replace('${degree}', summary.emos.attention.strengthDesc)}} />
          <p>{i18n.report.summaryInfo2}<strong>{summary.mbti && (summary.mbti.mbtiType + summary.mbti.result.split('——')[0])} </strong>{summary.mbti && '——' + summary.mbti.result.split('——')[1]}</p>
        </div>
        <div className="summaryTitle">{i18n.result.summaryInfo}</div>
        <div className="summaryPieBox">
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
          />
          {summary && summary.emos && <OtherTable columns={columns()} dataSource={dataSource()} />}
        </div>
      </div>
    );
  }
}

export default Conclusion;
